module.exports = __webpack_public_path__ + "static/meda-provider3-0ee940628517961919bea882436739d8.png";